/*! menuFullpage - v1.0.0 - 2015-03-26
* https://github.com/rottenstudios/menufullpage
* Copyright (c) 2015 Carmelo Catalfamo - rottenStudios.it */
! function(e) {
    "use strict";
    e.fn.menufullpage = function(s) {
        var t = e.extend({
                body: "body",
                menu: "#fullpage-nav",
                push: ".push",
                side: "left",
                menuWidth: "100%",
                speed: "400",
                activeBtn: "menufullpage-menu-open"
            }, s),
            n = this,
            i = e(t.menu),
            a = e(t.push),
            o = t.menuWidth,
            c = {
                /*position: "fixed",
                top: "0",
                bottom: "0",
                "settings.side": "-" + t.menuWidth,
                width: t.menuWidth,
                height: "100%"*/
            },
            d = {
                /*"-webkit-transition": t.side + " " + t.speed + "ms ease",
                "-moz-transition": t.side + " " + t.speed + "ms ease",
                "-ms-transition": t.side + " " + t.speed + "ms ease",
                "-o-transition": t.side + " " + t.speed + "ms ease",
                transition: t.side + " " + t.speed + "ms ease"*/
            };
        return i.css(c), a.css(t.side, "0"), i.css(d), a.css(d), i._state = "closed", i.open = function() {
            i._state = "open", i.addClass(t.activeBtn), e(t.body).addClass(t.activeBtn), a.css(t.side, o), n.addClass(t.activeBtn)
        }, i.close = function() {
            i._state = "closed", i.removeClass(t.activeBtn), e(t.body).removeClass(t.activeBtn), a.css(t.side, "0"), n.removeClass(t.activeBtn)
        }, e(document).on("click.menufullpage", function(s) {
            e(s.target).parents().andSelf().is(n) || "open" !== i._state || (i.close(), n.removeClass(t.activeBtn))
        }), n.on("click.menufullpage", function(e) {
            e.preventDefault(), "closed" === i._state ? i.open() : i.close()
        }), n.on("touchend", function(e) {
            n.trigger("click.menufullpage"), e.preventDefault()
        }), i
    }
}(jQuery);